import { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { PencilIcon, CheckIcon, XMarkIcon } from '@heroicons/react/20/solid';

export default function InlineEdit({ value, placeholder, onSave, className = '' }) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(value || '');
  const inputRef = useRef(null);

  useEffect(() => {
    if (editing) inputRef.current?.focus();
  }, [editing]);

  const commit = () => {
    setEditing(false);
    if (draft.trim() !== (value || '')) onSave(draft.trim());
  };

  const cancel = () => {
    setDraft(value || '');
    setEditing(false);
  };

  if (editing) {
    return (
      <span className="inline-flex items-center gap-1">
        <input
          ref={inputRef}
          value={draft}
          onChange={e => setDraft(e.target.value)}
          onKeyDown={e => { if (e.key === 'Enter') commit(); if (e.key === 'Escape') cancel(); }}
          className="border border-cyan-400 rounded px-2 py-0.5 text-sm focus:outline-none focus:ring-1 focus:ring-cyan-500"
          placeholder={placeholder}
        />
        <button onClick={commit} className="text-green-600 hover:text-green-800"><CheckIcon className="size-4" /></button>
        <button onClick={cancel} className="text-gray-400 hover:text-gray-600"><XMarkIcon className="size-4" /></button>
      </span>
    );
  }

  return (
    <span className={`inline-flex items-center gap-1 group cursor-pointer ${className}`} onClick={() => setEditing(true)}>
      <span>{value || <span className="text-gray-400 italic">{placeholder}</span>}</span>
      <PencilIcon className="size-3.5 text-gray-300 group-hover:text-cyan-500 transition-colors" />
    </span>
  );
}

InlineEdit.propTypes = {
  value: PropTypes.string,
  placeholder: PropTypes.string,
  onSave: PropTypes.func.isRequired,
  className: PropTypes.string,
};
